var _path, _path2, _path3, _path4, _path5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRentalCoverage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.955 9.5H5.754C5.4215 9.5 5.1025 9.632 4.8675 9.8675C4.632 10.1025 4.5 10.4215 4.5 10.754V20.934C4.5 22.41 5.0865 23.8255 6.13 24.869C7.1735 25.9125 8.5895 26.499 10.0655 26.499C11.1805 26.499 12.354 26.499 13.4725 26.499C14.9655 26.499 16.3955 25.8995 17.442 24.8345C18.4885 23.77 19.063 22.3295 19.037 20.837C19.0215 19.933 19.01 19.2885 19.01 19.2885",
    stroke: "#6F757C",
    strokeWidth: 1.5,
    strokeMiterlimit: 5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.1325 16L24.1295 18.8215L22.8905 20.8505L24.1355 23L22.8905 25.3665C22.8905 25.3665 24.056 27.6645 24.132 27.814C24.1345 27.819 24.1355 27.8245 24.1355 27.83C24.132 28.244 23.905 28.6235 23.5425 28.823C22.6045 29.339 20.768 30.349 19.741 30.914C19.586 30.999 19.3975 30.996 19.2455 30.906C19.0935 30.816 19 30.6525 19 30.476V16H16C16 16 14.981 10.4265 14.343 6.93352C14.218 6.25202 14.4025 5.55002 14.8465 5.01802C15.29 4.48602 15.947 4.17852 16.6395 4.17852H19.2315C19.1685 3.96302 19.1355 3.73452 19.1355 3.49902C19.1355 2.11952 20.256 0.999023 21.6355 0.999023C23.0155 0.999023 24.1355 2.11952 24.1355 3.49902C24.1355 3.73452 24.103 3.96302 24.0395 4.17852H26.3605C27.053 4.17852 27.71 4.48602 28.1535 5.01802C28.5975 5.55002 28.782 6.25202 28.657 6.93352C28.019 10.4265 27 16 27 16H24.1325V16Z",
    stroke: "#6F757C",
    strokeWidth: 1.5,
    strokeMiterlimit: 2
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M18.5 16H24.5",
    stroke: "#6F757C",
    strokeWidth: 1.5,
    strokeMiterlimit: 5
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M11.7617 9.999V3.9505C11.7617 3.4335 11.9672 2.937 12.3332 2.5715C12.6992 2.2055 13.1952 2 13.7127 2C16.5902 2 21.6357 2 21.6357 2V4",
    stroke: "#6F757C",
    strokeWidth: 1.5,
    strokeMiterlimit: 5
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M19.0391 9.5H24.1601",
    stroke: "#6F757C",
    strokeWidth: 1.5,
    strokeMiterlimit: 5,
    strokeLinecap: "square"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRentalCoverage);
export default __webpack_public_path__ + "static/media/rental-coverage.c309d6d780ddcf19e5e8b7508a9ad341.svg";
export { ForwardRef as ReactComponent };